/* eslint-disable no-underscore-dangle */
window.__CGC = window.__CGC || {};

const getQueryParam = (name, url = null) => new URL(url || window.location.href).searchParams.get(name);

window.__CGC.buyGiftMembership = {
  gift_memberships: {
    gift_membership_gin_1: 42443781079220,
    gift_membership_gin_2: 42443778326708,
    gift_membership_gin_3: 43689730736308,
    gift_membership_gin_4: 30745917882426,
    gift_membership_gin_5: 32642639757390,
    gift_membership_gin_6: 30745917849658,
    gift_membership_gin_12: 30745917816890,
    gift_membership_rum_1: 43689732309172,
    gift_membership_rum_2: 43689732276404,
    gift_membership_rum_3: 43689732243636,
    gift_membership_rum_4: 43689732210868,
    gift_membership_rum_5: 32642639757390,
    gift_membership_rum_6: 43689732178100,
    gift_membership_rum_12: 43689732145332,
    gotm: 41619340984500,
  },

  async getVariantId() {
    const type = getQueryParam('type') || 'gotm';
    const variantId = this.gift_memberships[type];

    return [type, variantId];
  },

  getDiscountCode() {
    let code = getQueryParam('discount_code');
    code = (code || '').toUpperCase();

    return code;
  },
};

class GiftPurchase extends HTMLElement {
  constructor() {
    super();
    this.spirit = null;
    this.numberBoxes = null;
    this.discountCode = '';
    this.isLoading = false;
    this.errors = false;
    this.recipientName = null;
    this.giftMessage = null;
    this.config = null;
    this.variantId = null;
    this.code = null;
    this.product = null;
    this.newLines = 0;
  }

  connectedCallback() {
    this.initializeComponent();
  }

  async initializeComponent() {
    // Initialize gift membership data
    this.code = await window.__CGC.buyGiftMembership.getDiscountCode();
    [this.product, this.variantId] = await window.__CGC.buyGiftMembership.getVariantId();

    const messageInput = this.querySelector('.field__input--textarea');
    messageInput.addEventListener('keydown', (event) => {
        this.validateMessage(event, messageInput.value, event.target.selectionStart);
      });

    // Initialize selling plan ID from Firebase config
    await this.initVariantAndSellingPlanId();

    this.bindEvents();
  }

  bindEvents() {
    // Spirit selection events
    this.querySelectorAll('.gift-spirit-option').forEach((spirit) => {
      spirit.addEventListener('click', () => {
        this.scrollDown();
        this.spirit = spirit.dataset.spirit;

        this.setSelectedOption();
        this.applyHoverPointer();
      });
    });

    // Box count selection events
    this.querySelectorAll('.gift-box-count-option').forEach((block) => {
      block.addEventListener('click', () => {
        this.selectBoxCount(block);
      });
    });

    // Gift message form events
    const messageForm = this.querySelector('#gift-message-form');
    if (messageForm) {
      messageForm.addEventListener('submit', this.handleSubmit.bind(this));
    }

    const backButton = this.querySelector('#back-to-selection');
    if (backButton) {
      backButton.addEventListener('click', () => {
        this.showSelectionSection();
      });
    }
  }

  setSelectedOption() {
    const options = this.querySelectorAll('.gift-spirit-option');

    options.forEach((option) => {
      option.classList.remove('gift-spirit-option--selected');
    });

    const selectedOption = this.querySelector(`.gift-spirit-option[data-spirit="${this.spirit}"]`);

    selectedOption.classList.add('gift-spirit-option--selected');
  }

  scrollToElement(element) {
    element.scrollIntoView({
      behavior: 'smooth',
    });
  }

  scrollDown() {
    const element = this.querySelector('#select-number-of-boxes');

    if (element) {
      this.scrollToElement(element);
    }
  }

  selectBoxCount(block) {
    if (!this.spirit) {
      const element = this.querySelector('#select-spirit');

      if (element) {
        this.scrollToElement(element);
      }
    } else {
      // Remove selected state from all box count options
      this.querySelectorAll('.gift-box-count-option').forEach((option) => {
        option.classList.remove('gift-box-count-option--selected');
      });

      // Add selected state to clicked option
      block.classList.add('gift-box-count-option--selected');

      this.numberBoxes = block.dataset.numberBoxes;

      // Get the discount code from the selected box count
      this.discountCode = block.dataset.discountCode || '';

      // Show gift message form instead of redirecting
      this.showMessageForm();
    }
  }

  showMessageForm() {
    // Hide selection sections
    const spiritSelection = this.querySelector('#gift-spirit-selection');
    const countSelection = this.querySelector('#gift-count-selection');
    const messageSection = this.querySelector('#gift-message-section');

    if (spiritSelection) spiritSelection.style.display = 'none';
    if (countSelection) countSelection.style.display = 'none';
    if (messageSection) {
      messageSection.style.display = 'block';
      this.scrollToElement(messageSection);
    }
  }

  showSelectionSection() {
    // Show selection sections and hide message form
    const spiritSelection = this.querySelector('#gift-spirit-selection');
    const countSelection = this.querySelector('#gift-count-selection');
    const messageSection = this.querySelector('#gift-message-section');

    if (spiritSelection) spiritSelection.style.display = 'block';
    if (countSelection) countSelection.style.display = 'block';
    if (messageSection) messageSection.style.display = 'none';

    // Reset selections
    this.querySelectorAll('.gift-box-count-option').forEach((option) => {
      option.classList.remove('gift-box-count-option--selected');
    });

    this.numberBoxes = null;
    this.discountCode = '';
  }

  async handleSubmit(event) {
    event.preventDefault();

    this.getGiftMessage();

    await this.proceedToCheckout();
  }

  getGiftMessage() {
    const name = this.querySelector('input[name="recipient_name"]');
    const message = this.querySelector('textarea[name="message"]');

    this.recipientName = name.value;
    this.giftMessage = message.value;
  }

  validateMessage(event, value, selectionStart) {
    const maxCharacters = 120;
    const newLineKeyCode = 13;
    const newLineCharCode = 10;
    const backspaceKeyCode = 8;
    const charCodes = value.split('').map((char) => char.charCodeAt(0));

    const newlineMatches = value.match(/\r?\n/g);
    this.newLines = newlineMatches?.length || 0;
    
    switch(event.keyCode) {
      case backspaceKeyCode:
        if (charCodes[selectionStart-1] === newLineCharCode && this.newLines > 0) {
          this.newLines -= 1;
        }
        this.hideErrorMessage();
        break;

      case newLineKeyCode:
        if (this.newLines >= 2) {
          event.preventDefault();
          this.showErrorMessage('Your message should be 3 lines of fewer.');
        }
        break;

      default:
        if (charCodes.length >= maxCharacters) {
          this.showErrorMessage(`Your message must be ${maxCharacters} characters or fewer.`);
        } 
        else {
          this.hideErrorMessage();
        }
    }
  }

  hideErrorMessage() {
    const errorField = this.querySelector('#gift-message-error');
    if (!errorField.classList.contains('hidden')) {
      errorField.classList.add('hidden');
    }
  }

  showErrorMessage(message) {
    const errorField = this.querySelector('#gift-message-error');
    errorField.innerHTML = message;
    errorField.classList.remove('hidden');
  }

  async proceedToCheckout() {
    this.setLoading(true);

    try {
      await this.clearCart();
      const formData = this.getFormData();
      const addResponse = await this.addToCart(formData);

      if (addResponse.ok) {
        await this.attachAnalyticsData();
        this.navigateToCheckout();
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Checkout error:', error);
      this.dispatchError('Failed to proceed to checkout');
    } finally {
      this.setLoading(false);
    }
  }

  async addToCart(formData) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
  }

  async attachAnalyticsData() {
    try {
      const { gaClientId, gaSessionId, fbp, fbc } = await getAnalyticsData();

      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            ga_client_id: gaClientId,
            ga_session_id: gaSessionId,
            fbp: fbp,
            fbc: fbc,
          },
        }),
      });
    } catch (error) {
      console.error('Error attaching analytics data:', error);
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  navigateToCheckout() {
    // Use discount code from selected box count, fallback to URL parameter, or empty string
    const discount = this.discountCode || this.code || '';
    const checkoutUrl = discount ? `/checkout?discount=${discount}` : '/checkout';

    this.dispatchEvent(
      new CustomEvent('checkout-redirect', {
        detail: { url: checkoutUrl },
      })
    );

    window.location.assign(checkoutUrl);
  }

  getFormData() {
    // Get the variant ID for the selected gift membership
    const giftType = `gift_membership_${this.spirit}_${this.numberBoxes}`;
    const variantId = window.__CGC.buyGiftMembership.gift_memberships[giftType];

    const formData = {
      items: [
        {
          id: variantId,
          ...(this.sellingPlanId ? { sellingPlanId: this.sellingPlanId } : {}),
          quantity: 1,
          properties: {
            recipient_name: this.recipientName,
            message: this.giftMessage,
          },
        },
      ],
    };

    return formData;
  }

  async clearCart() {
    return fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
    });
  }

  setLoading(loading) {
    this.isLoading = loading;
    this.dispatchEvent(
      new CustomEvent('loading-state-change', {
        detail: { loading },
      })
    );

    const button = this.querySelector('#submit-gift');
    const spinner = this.querySelector('.loading__spinner');

    if (loading) {
      if (button) button.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
    } else {
      if (button) {
        button.disabled = false;
        button.textContent = 'Continue to checkout';
      }
      if (spinner) spinner.classList.add('hidden');
    }
  }

  dispatchError(message) {
    this.errors = true;
    this.dispatchEvent(
      new CustomEvent('error', {
        detail: { message },
      })
    );
  }

  getProductHandleFromConfig(handle, config) {
    if (handle === 'gotm') return config.gotmMaster;
    return handle;
  }

  async getFirebaseConfig() {
    if (!this.config) {
      const configResponse = await fetch(`${window.ENV_VARS.firebaseApiUrl}/${window.ENV_VARS.firebaseApiConfig}`);
      const data = await configResponse.json();
      this.config = data.config;
    }
    return this.config;
  }

  async initVariantAndSellingPlanId() {
    try {
      const config = await this.getFirebaseConfig();
      const productHandle = this.product;
      const handle = this.getProductHandleFromConfig(productHandle, config);

      if (this.product === 'gotm' && config.products && config.products[handle]) {
        const { variantId, sellingPlanId } = config.products[handle];
        this.variantId = variantId;
        this.sellingPlanId = sellingPlanId;
      }
    } catch (error) {
      console.error('Error initializing variant and selling plan:', error);
    }
  }

  applyHoverPointer() {
    if (this.spirit) {
      return;
    }

    this.querySelectorAll('.gift-box-count-option').forEach((block) => {
      block.addEventListener('mouseover', () => {
        block.style.cursor = 'pointer';
      });
    });
  }
}

if (!customElements.get('gift-purchase')) {
  customElements.define('gift-purchase', GiftPurchase);
}
